import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-onboard-container',
  templateUrl: './onboard-container.component.html',
  styleUrls: ['./onboard-container.component.css']
})
export class OnboardContainerComponent implements OnInit {

  selectedOption:any;
  isSubmitted = false;
  lessons: [];
  formQuestion: FormGroup;

  constructor( private formBuilder: FormBuilder,private router: Router) {  this.formQuestion = this.formBuilder.group({

    id: ['', [Validators.required]],
    location: ['', [Validators.required]],

    division: ['', [Validators.required]],
    scale: ['', [Validators.required]],
    divNumber: ['', [Validators.required]],
    challanNumber: ['', [Validators.required]],
    year: ['', [Validators.required]],
    weight: ['', [Validators.required]],
    opium: ['', [Validators.required]],
    containerYear: ['', [Validators.required]],
    totalWeight: ['', [Validators.required]],
    stage: ['', [Validators.required]],
    cultivator: ['', [Validators.required]],
    fatherName: ['', [Validators.required]],
    license: ['', [Validators.required]],
    village: ['', [Validators.required]],
    tehsil: ['', [Validators.required]],
    center: ['', [Validators.required]],
    weightDate: ['', [Validators.required]],
    packet: ['', [Validators.required]],
    bag: ['', [Validators.required]],
    class: ['', [Validators.required]],
    reciever: ['', [Validators.required]],
    recieverTime: ['', [Validators.required]],
    recieverDate: ['', [Validators.required]],
    
    // endDate: ['', [Validators.required]],
    // tokens: ['', [Validators.required]]
  })
 }

  ngOnInit(): void {
  }
  closeResult = '';


  // open(content) {
  //   this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
  //     this.closeResult = `Closed with: ${result}`;
  //   }, (reason) => {
  //     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //   });
  // }

  // private getDismissReason(reason: any): string {
  //   if (reason === ModalDismissReasons.ESC) {
  //     return 'by pressing ESC';
  //   } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
  //     return 'by clicking on a backdrop';
  //   } else {
  //     return `with: ${reason}`;
  //   }
  // }

  onSubmit(){
    // alert()
    // console.log(this.formDoctor)
    this.isSubmitted = true;
    if (this.formQuestion.invalid) {
      return;
    }
    else{
      // this.router.navigateByUrl('/survey-participation/questions-list');

    }
  }

  model: any = {};
  isLoading !: boolean;
  ngForm: any;
  fieldTextType!: boolean;

  formRegister: FormGroup;
  // isSubmitted = false;
  fieldTextType1 !: boolean;
  userName: any;
  isUser: any;
  isShowMessage : boolean = true;
  organizations: any;
  userExists: any;
  formRegisterOrg: FormGroup;
  activeColor: string = 'green';
  baseColor: string = '#ccc';
  overlayColor: string = 'rgba(255,255,255,0.5)';

  dragging: boolean = false;
  loaded: boolean = false;
  imageLoaded: boolean = false;
  imageSrc: string | undefined
  filename: any;
  isSubmittedOrg: boolean = false;

  handleDragEnter() {
      this.dragging = true;
  }

  handleDragLeave() {
      this.dragging = false;
  }

  handleDrop(e : any) {
      e.preventDefault();
      this.dragging = false;
      this.handleInputChange(e);
  }

  handleImageLoad() {
      this.imageLoaded = true;
  }

  displayStyle = "none";
  
  openPopup() {
    this.displayStyle = "block";
  }
  closePopup() {
    this.displayStyle = "none";
  }

  handleInputChange(e : any) {
   // console.log(e)

      var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    //console.log(file.name)
    this.filename = file.name;
      var pattern = /image-*/;
      var reader = new FileReader();

      if (!file.type.match(pattern)) {
          alert('invalid format');
          return;
      }

      this.loaded = false;

      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e : any) {
   // console.log(e)
      var reader = e.target;

      this.imageSrc = (reader.result as string).split(',').pop();

      this.loaded = true;
  }



}
